<template>
  <div>
    <!-- Empty state -->
    <div v-if="!count" class="flex flex-col items-center">
      <star-rating :count="0" :average="0" :show-count="false" class="!py-0" />
      <!-- Sitter view -->
      <div v-if="showSitterView">
        <p class="text-strong-body text-grey-body text-center mt-8">No reviews yet</p>
        <p class="text-body text-grey-body text-center mt-8">Request a review to add it to your profile</p>
      </div>
      <!-- Default view -->
      <p v-else-if="isBasic" class="text-body mt-8">
        <a class="underline text-primary primary-focus" href="/upgrade/pricing">Upgrade</a> to leave a review
      </p>
      <p v-else class="text-body mt-8">Be the first to leave a review</p>
    </div>

    <!-- Star Rating + Distribution -->
    <div v-else-if="validAverage" class="flex items-center gap-24">
      <div>
        <star-rating :count="count" :average="average" :show-count="false" class="!py-0" />
        <div class="flex items-center gap-8 mt-8">
          <p class="text-h3 text-brand">{{ formattedStarRating }}</p>
          <p class="text-body text-grey-text-subdued whitespace-nowrap">({{ countDisplayText }})</p>
        </div>
      </div>
      <ratings-distribution :distribution-data="distributionData" />
    </div>
  </div>
</template>

<script lang="ts">
import pluralize from 'pluralize';
import StarRating from '../star_rating/StarRating.vue';
import RatingsDistribution from '../ratings_distribution/RatingsDistribution.vue';

const LIMIT = 5;

interface DistributionData {
  count: number;
  percent: number;
  stars: number;
}

export default {
  name: 'RatingsOverview',
  components: { StarRating, RatingsDistribution },
  props: {
    count: {
      type: Number,
      required: true,
    },
    average: {
      type: Number,
      required: true,
    },
    distributionData: {
      type: Array as () => Array<DistributionData>,
      default: () => [],
    },
    showSitterView: {
      type: Boolean,
      default: false,
    },
    isBasic: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    validAverage(): boolean {
      return this.average !== null && this.average >= 0 && this.average <= LIMIT;
    },
    formattedStarRating(): string {
      return this.average.toFixed(1);
    },
    countDisplayText(): string {
      return pluralize('rating', this.count, true);
    },
  },
};
</script>
